import { render, staticRenderFns } from "./DocumentsListTable.vue?vue&type=template&id=40910cc1&"
import script from "./DocumentsListTable.vue?vue&type=script&lang=js&"
export * from "./DocumentsListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports